import request from "./tsa";

export const sendReport = data =>
    request({
        url: `/content/api/sendTools/report`,
        method: "post",
        data,
    });

export const getPrecedent = data =>
    request({
        url: `/content-plus/api/precedentStatistics/searchNew`,
        method: "get",
    });
    